<template>
  <div>
    <div class="ti-highlight">
      <h3 id="highlight_text" class="wrap-around-text">{{ highlight }}</h3>
    </div>
    <div class="promo-img">
      <img id="image_url" :src="imageUrl" style="width: 100%;" alt="B-Infinite" />
    </div>
    <div class="promo-content">
      <h4 id="title_text" class="wrap-around-text">{{ title }}</h4>

      <div class="promo-info">
        <div class="promo-text wrap-around-text">
          <p id="promo_text" v-html="promoText" style="margin-right: 15px;"></p>
        </div>
        <div class="promo-btn" style="align-self: flex-end; margin-bottom: 15px;">
          <a id="button_text" :href="buttonUrl">{{ buttonText }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "dataHighlight",
    "dataImageUrl",
    "dataTitle",
    "dataPromoText",
    "dataButtonUrl",
    "dataButtonText"
  ],
  data() {
    return {
      highlight: this.dataHighlight,
      imageUrl: this.dataImageUrl,
      title: this.dataTitle,
      promoText: this.dataPromoText,
      buttonUrl: this.dataButtonUrl,
      buttonText: this.dataButtonText
    };
  }
};
</script>
